"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationClaimDto = instanceOfOrientationClaimDto;
exports.OrientationClaimDtoFromJSON = OrientationClaimDtoFromJSON;
exports.OrientationClaimDtoFromJSONTyped = OrientationClaimDtoFromJSONTyped;
exports.OrientationClaimDtoToJSON = OrientationClaimDtoToJSON;
exports.OrientationClaimDtoToJSONTyped = OrientationClaimDtoToJSONTyped;
const ShiftMatchProfileDto_1 = require("./ShiftMatchProfileDto");
const OrientationClaimShiftStatsDto_1 = require("./OrientationClaimShiftStatsDto");
/**
 * Check if a given object implements the OrientationClaimDto interface.
 */
function instanceOfOrientationClaimDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('shiftStats' in value) || value['shiftStats'] === undefined)
        return false;
    return true;
}
function OrientationClaimDtoFromJSON(json) {
    return OrientationClaimDtoFromJSONTyped(json, false);
}
function OrientationClaimDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoFromJSON)(json['nurseProfile']),
        'shiftStats': (0, OrientationClaimShiftStatsDto_1.OrientationClaimShiftStatsDtoFromJSON)(json['shiftStats']),
    };
}
function OrientationClaimDtoToJSON(json) {
    return OrientationClaimDtoToJSONTyped(json, false);
}
function OrientationClaimDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoToJSON)(value['nurseProfile']),
        'shiftStats': (0, OrientationClaimShiftStatsDto_1.OrientationClaimShiftStatsDtoToJSON)(value['shiftStats']),
    };
}
//# sourceMappingURL=OrientationClaimDto.js.map